export const fr = {
  pageTitle: "Cartes cadeaux",
  searchPlaceholder: "Rechercher des cartes cadeaux",
  helpShop: "Parcourez les cartes cadeaux et voyez les recompenses offertes.",
  helpMyCards: "Consultez les cartes cadeaux que vous avez deja achetees.",
  tabShop: "Boutique",
  tabMyCards: "Mes cartes",
  loading: "Chargement des cartes cadeaux...",
  defaultBrand: "Carte cadeau",
  noArtwork: "Aucune image",
  unavailableTitle: "Les cartes cadeaux ne sont pas disponibles",
  unavailableBody:
    "Nous ne pouvons pas charger les cartes cadeaux pour le moment. Reessayez plus tard.",
  shopErrorTitle: "Impossible de charger les cartes cadeaux",
  shopErrorBody: "Actualisez la page ou reessayez dans un moment.",
  catalogEmptyTitle: "Aucune carte cadeau trouvee",
  catalogEmptyBody: "Essayez une autre recherche ou un autre pays.",
  signInTitle: "Connectez-vous pour voir vos cartes cadeaux",
  signInBody: "Vos cartes cadeaux achetees sont disponibles apres connexion.",
  signIn: "Se connecter",
  bagEmptyTitle: "Aucune carte cadeau",
  bagEmptyBody: "Les cartes cadeaux que vous achetez apparaitront ici.",
  noMatches: "Aucune carte cadeau correspondante",
  earnUpToPercentBack: "Gagnez jusqu'a {{value}} % en retour",
  earnUpToCashBack: "Gagnez jusqu'a {{amount}} en retour",
  continueToPurchase: "Continuer vers l'achat",
  selectAmount: "Choisissez un montant",
  customAmount: "Montant personnalise",
  customAmountPlaceholder: "Entrez un montant",
  amountRangeHint: "Entrez un montant entre {{min}} et {{max}}",
  amountMinHint: "Entrez au moins {{min}}",
  amountMaxHint: "Entrez au plus {{max}}",
  amountInvalid: "Entrez un montant valide",
  back: "Retour",
  youPay: "Vous payez",
  youEarn: "Vous gagnez",
  paymentHeadlinePrefix: "Vous payez {{amount}}",
  paymentHeadlineJoiner: "et",
  paymentHeadlineReward: "gagnez {{reward}}",
  paymentHeadlineRewardType: "en argent ({{currency}})",
  paymentMethod: "Mode de paiement",
  confirmPay: "Confirmer et payer {{amount}}",
  signInToPurchase: "Connectez-vous pour acheter",
  processing: "Traitement de votre achat...",
  addNewCard: "Ajouter une carte",
  card: "Carte",
  cardEndingIn: "Se terminant par {{last4}}",
  cardExpires: "Exp {{month}}/{{year}}",
  cardDetails: "Details de la carte",
  postalCode: "Code postal",
  postalCodePlaceholder: "A1A 1A1",
  saveCard: "Enregistrer la carte",
  savingCard: "Enregistrement...",
  cancel: "Annuler",
  stripeUnavailable: "Les paiements par carte ne sont pas disponibles pour le moment.",
  cardSetupError: "Impossible de demarrer la configuration de la carte. Reessayez.",
  cardError:
    "Impossible d'enregistrer votre carte. Verifiez les informations et reessayez.",
  methodsError: "Impossible de charger vos cartes enregistrees.",
  paymentError: "Votre paiement n'a pas pu etre complete. Veuillez reessayer.",
  cardDeclined: "Votre carte a ete refusee. Essayez une autre carte.",
  insufficientFunds: "Fonds insuffisants sur votre carte. Essayez une autre carte.",
  purchaseComplete: "Achat termine",
  purchaseCompleteBody: "Votre carte cadeau de {{amount}} est prete dans Mes cartes.",
  youPaid: "Vous avez paye",
  youEarned: "Vous avez gagne",
  viewMyWallet: "Voir mon portefeuille",
  cardNumber: "Numero de carte",
  pin: "NIP",
  barcodeAlt: "Code-barres de la carte cadeau",
  noImage: "Aucune image disponible",
  amount: "Montant",
  purchasedFor: "Achetee pour",
  balance: "Solde",
  description: "Description",
  howToUse: "Comment l'utiliser",
  terms: "Conditions generales",
  emptyDetails: "Aucun detail supplementaire n'est disponible.",
  close: "Fermer",
};
